import { useState } from "react";
import { ClipboardList, Copy, Check, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const CALL_FORM_TITLE = "Wellbeing / Coaching / Mentoring Call Form";
export const CALL_FORM_TEXT = `WELLBEING / COACHING / MENTORING CALL FORM

1) WHAT ARE THE 3 MAIN THINGS YOU WOULD LIKE TO DISCUSS OR GET PERSPECTIVE ON:

2) WHAT DAY ARE YOU ON YOUR CORE RUN?

3) TELL US ABOUT YOUR BIZ:
A) What is your current Personal PV?
B) Did you create your turnover on 1st Day of the Month?
C) What is your current structure?
D) What is your current Group PV?
E) Have you bought your Tickets for the next conference?

4) TELL US ABOUT YOUR TRACKING LAST MONTH: (Please make sure your data is up to date on Team Smith Hub)

5) HOW MANY PEOPLE DO YOU CURRENTLY HAVE IN THE PROCESS?
(Please make sure your data is up to date on Team Smith Hub)

6) WHAT ARE YOUR GOALS:
A) Conference Goal (Structure):
B) Monthly Goal:
C) Weekly Goal:`;

async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; } catch { /* fall back for older mobile browsers */ }
  const ta = document.createElement("textarea");
  ta.value = text; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
  document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
  const ok = document.execCommand("copy");
  document.body.removeChild(ta);
  return ok;
}

export default function CallFormCard({ testid = "call-form" }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(null);
  const copy = async () => {
    const ok = await copyText(CALL_FORM_TEXT);
    setCopied(ok ? "ok" : "fail");
    setTimeout(() => setCopied(null), 2500);
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`${testid}-open`}
              className="group w-full text-left flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2.5 min-h-[52px] hover:border-[#C9A961] transition-colors">
        <ClipboardList className="w-5 h-5 text-[#8A6D1F] shrink-0" />
        <span className="flex-1 min-w-0 text-[15px] font-semibold text-[#0A1F44] break-words">{CALL_FORM_TITLE}</span>
        <span className="text-[10px] uppercase tracking-wider font-semibold text-[#8A6D1F] bg-[#C9A961]/15 rounded px-1.5 py-0.5 shrink-0">Copy form</span>
        <ArrowRight className="w-4 h-4 text-[#C9A961] shrink-0 transition-transform group-hover:translate-x-0.5" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg w-[calc(100vw-1.5rem)] max-h-[90vh] flex flex-col" data-testid={`${testid}-modal`}>
          <DialogHeader>
            <DialogTitle className="font-serif text-[#0A1F44] pr-6">{CALL_FORM_TITLE}</DialogTitle>
            <DialogDescription data-testid={`${testid}-intro`}>
              Please copy this form, paste it into your Telegram conversation with your coach or mentor, and complete your answers before requesting your call.
            </DialogDescription>
          </DialogHeader>
          <pre className="flex-1 min-h-0 overflow-auto whitespace-pre-wrap break-words rounded-lg bg-slate-50 border border-slate-200 p-3 text-[13px] leading-relaxed font-sans text-slate-800 select-text"
               data-testid={`${testid}-text`}>{CALL_FORM_TEXT}</pre>
          <div className="flex items-center gap-3 pt-1">
            <Button onClick={copy} className="h-11 rounded-full bg-[#0A1F44] text-white px-5" data-testid={`${testid}-copy`}>
              {copied === "ok" ? <Check className="w-4 h-4 mr-2" /> : <Copy className="w-4 h-4 mr-2" />}Copy Form
            </Button>
            <span role="status" aria-live="polite" className="text-sm font-medium" data-testid={`${testid}-copy-status`}>
              {copied === "ok" && <span className="text-emerald-700">Copied to Clipboard!</span>}
              {copied === "fail" && <span className="text-red-700">Couldn't copy — press and hold the text to select it.</span>}
            </span>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
